import DeletedWordsVisibilityButton from './DeletedWordsVisibilityButton';
import PlayButton from './PlayButton';
import ProgressBar from './ProgressBar';
import * as S from './styles';

export interface PlaybarProps {
  className?: string;
}

const Playbar: React.FC<PlaybarProps> = ({ className }) => (
  <S.Container className={className}>
    <S.Content>
      <PlayButton />
      <ProgressBar />
      <DeletedWordsVisibilityButton />
    </S.Content>
  </S.Container>
);

export default Playbar;
